'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _radioItem = require('./radio-item.vue');

var _radioItem2 = _interopRequireDefault(_radioItem);

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [_colmo2.default],
  components: { RadioItem: _radioItem2.default },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 是否宽度750（边框样式不一样）
    isFullBorder: {
      type: Boolean,
      default: true
    },
    // 是否显示边框
    isShowBorder: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      checkedIndex: -1
    };
  },
  watch: {
    list: function list(newValue, oldValue) {
      this.computedCheckedIndex();
    }
  },
  computed: {
    updateList: function updateList() {
      var checkedIndex = this.checkedIndex,
          list = this.list;

      var updateList = [];
      list && list.forEach(function (item, i) {
        item.checked = i === checkedIndex;
        updateList.push(item);
      });
      return updateList;
    }
  },
  created: function created() {
    this.computedCheckedIndex();
  },

  methods: {
    computedCheckedIndex: function computedCheckedIndex() {
      var _this = this;

      var list = this.list;

      if (list && list.length > 0) {
        list.forEach(function (item, i) {
          item.checked && (_this.checkedIndex = i);
        });
      }
    },
    dofRadioItemChecked: function dofRadioItemChecked(i, e) {
      var oldIndex = this.checkedIndex;
      var _list$i = this.list[i],
          value = _list$i.value,
          title = _list$i.title;

      this.checkedIndex = i;
      this.$emit('dofRadioItemChecked', { value: value, title: title, oldIndex: oldIndex, index: i });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-radio-list/index.vue
// module id = 367
// module chunks = 0 1